export default {
  lgpd: {
    text1:
      'Usamos cookies para coletar informações sobre como você interage com nosso site, permitindo melhorar e personalizar sua experiência de navegação e realizar análises e métricas sobre nossos visitantes. Para obter mais informações, leia nossa',
    link: 'Politica de cookies.',
    text2: 'Ao clicar em Eu Concordo, você aceita a utilização desses cookies.',
    buttonContent: 'Eu concordo',
  },
}
